<section class="flex flex-col gap-3">
  <section class="flex w-full justify-between items-center">
    <div class="flex gap-3 items-center">
      <ng-content name="[selects]" />
      <label class="focus-within:input-primary input min-w-[25rem]">
        <app-icon name="mdi:search" />
        <input
          appInput
          [(value)]="query"
          [debounce]="300"
          type="text"
          placeholder="검색어를 입력해주세요."
          required
        />
      </label>
    </div>
    <div class="flex items-center gap-2">
      <ng-content name="[buttons]" />
      <button (click)="exportExcel()" class="btn btn-square btn-ghost btn-sm">
        <img
          class="w-6 h-6"
          src="https://api.iconify.design/vscode-icons/file-type-excel2.svg"
        />
      </button>
    </div>
  </section>
  @if (currentOrderBy()) {
    <section class="flex w-full justify-between items-center">
      <div class="flex items-center gap-2">
        <div class="badge badge-primary rounded-xl font-medium">
          <div class="flex items-center gap-1">
            <app-icon
              size="sm"
              [name]="
                align() === 'asc'
                  ? 'ic:outline-arrow-upward'
                  : 'ic:outline-arrow-downward'
              "
            />
            {{ currentOrderBy() }}
          </div>
        </div>
        @if (selecteds() && selecteds()!.length > 0) {
          <div class="badge badge-primary rounded-xl font-medium">
            <div class="flex items-center gap-1">
              <app-icon class="!size-5" name="ic:sharp-discount" /> 선택된 갯수
              : {{ selecteds()!.length }}
            </div>
          </div>
        }
      </div>
      <button
        [cdkMenuTriggerFor]="menu"
        class="btn btn-square btn-ghost btn-sm"
      >
        <app-icon name="mdi:dots-vertical" />
      </button>
    </section>
  }
</section>

<ng-template #menu>
  <app-menu cdkMenu>
    @for (option of aligns; track $index) {
      <div class="relative group">
        <app-menu-option icon="ic:baseline-chevron-left">
          <div class="flex items-center justify-end w-full gap-2">
            <p>{{ option === 'desc' ? '내림차순' : '오름차순' }}</p>
            <app-icon
              [name]="
                option === 'desc'
                  ? 'ic:outline-arrow-downward'
                  : 'ic:outline-arrow-upward'
              "
              size="sm"
            />
          </div>
        </app-menu-option>
        <app-menu
          class="absolute right-[calc(100%)] top-0 hidden group-hover:block"
        >
          @for (column of columns(); track column.field) {
            @if (column.field !== 'rowNumber' && column.field !== 'checkbox') {
              <app-menu-option
                (click)="handleOrderBy(option, column.alias || column.field)"
                cdkMenuItem
                [active]="
                  column.name === currentOrderBy() && align() === option
                "
                >{{ column.name }}</app-menu-option
              >
            }
          }
        </app-menu>
      </div>
    }
  </app-menu>
</ng-template>
